/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef ,useEffect} from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/GreenBike/bikeShell.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation10.play();
    actions.Animation10.repetitions = 1;
    actions.Animation10.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="shell">
          <mesh geometry={nodes.圓柱體003.geometry} material={materials['材質.010']} />
          <mesh geometry={nodes.圓柱體003_1.geometry} material={materials['材質.006']} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/GreenBike/bikeShell.glb')
